module.exports = __webpack_public_path__ + "img/dataCensus_reward.923d4103.svg";